import * as React from 'react';

import { Link } from 'react-router-dom';

const SessionExpired = () => (
  <div>
    <h1>Session Expired</h1>
    <p>Your session has expired. <Link to="/login" style={{textDecoration: 'underline'}}>Please log in again.</Link></p>
  </div>
)
export default SessionExpired;


// WEBPACK FOOTER //
// ./src/common/routes/session-expired.tsx